import { render, staticRenderFns } from "./applicant-onboarding-card.vue?vue&type=template&id=de848fd0&scoped=true"
import script from "./applicant-onboarding-card.vue?vue&type=script&lang=js"
export * from "./applicant-onboarding-card.vue?vue&type=script&lang=js"
import style0 from "./applicant-onboarding-card.vue?vue&type=style&index=0&id=de848fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de848fd0",
  null
  
)

export default component.exports